import {useQuery} from '@tanstack/react-query';
import {rqCreateRequest, rqCreateSearchRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {
  RQ_GET_DATE_FILTER_API,
  RQ_GET_MTP_REPORTS_API, RQ_GET_SALON_MTP_DETAILS,
  RQ_GET_SALON_MTP_LIST_FOR_MONTH, RQ_TOURPLAN_APPROVE_API,
} from '@app/reactQuery/apis/constants';

export const RQUseGetMTPReportsData = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_mtp_reports_data', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, locationId, startDate, endDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_MTP_REPORTS_API,
        null,
        certificate,
        {
          locationId: locationId,
          fromYearMonthDate: startDate,
          toYearMonthDate: endDate,
        },
        signal,
      );
    },
    ...options,
  });
};

export const RQUseGetDateFilter = (payload, options = {}) => {
  return useQuery({
    queryKey:['rq_get_date_filter', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, userId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_DATE_FILTER_API,
        null,
        certificate,
        {userId: userId},
        signal,
      );
    },
    ...options,
  });
};

export const RQSalonMtpForMonth = (payload, options = {}) => {
  return useQuery({
    queryKey:['RQ_GET_SALON_MTP_LIST_FOR_MONTH', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, managerId, fromDate, toDate} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SALON_MTP_LIST_FOR_MONTH,
        null,
        certificate,
        {managerId: managerId, fromDate: fromDate, toDate: toDate},
        signal,
      );
    },
    ...options,
  });
};

export const RQSalonMtpPlanDetails = (payload, options = {}) => {
  return useQuery({
    queryKey:['RQ_GET_SALON_MTP_DETAILS', payload],
    queryFn: async ({queryKey, signal}) => {
      const {certificate, mtpId} = queryKey[1];
      return rqCreateSearchRequest(
        RQ_GET_SALON_MTP_DETAILS,
        null,
        certificate,
        {mtpId: mtpId},
        signal,
      );
    },
    ...options,
  });
};

export const RQTourPlanApproveAPI = async ({
  mtpId,
  certificate,
  signal,
}) => {
  return rqCreateRequest(
    RQ_TOURPLAN_APPROVE_API,
    null,
    certificate,
    {mtpId: mtpId},
    signal,
  );
};
